import { useRef } from "react";
import ModalPop from "./ModalPop";

const Service = () => {
  const serviceList = [
    {
      img: "/images/service1.png",
      txt1: "유품정리 서비스",
    },
    {
      img: "/images/service2.png",
      txt1: "쓰레기집청소 서비스",
    },
    {
      img: "/images/service3.png",
      txt1: "특수청소 서비스",
    },
    {
      img: "/images/service4.png",
      txt1: "고독사청소 서비스",
    },
    {
      img: "/images/service5.png",
      txt1: "빈집정리 서비스",
    },
    // {
    //   img: "/images/service6.png",
    //   txt1: "창고정리 서비스",
    // },
    // {
    //   img: "/images/service7.png",
    //   txt1: "이사정리 서비스",
    // },
    {
      img: "/images/service8.png",
      txt1: "폐기물처리 서비스",
    },
    {
      img: "/images/service9.png",
      txt1: "철거 · 원상복구 서비스",
    },
  ];

  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <div
      id="service"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28"
    >
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div
        id="title"
        className="relative w-full h-fit text-center mb-5 xl:mb-10"
      >
        <h2 className="font-medium">
          <span className="text-primary">청소의&nbsp;달인</span>{" "}
          서비스&nbsp;목록
        </h2>
      </div>
      <div className="relative w-full h-fit max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-3 gap-5 lg:gap-6 border-t-2 border-dotted pt-5 xl:pt-10">
        {serviceList.map((v, i) => (
          <div
            key={i}
            data-aos="fade-up"
            className="relative w-full h-full p-3 lg:p-5 border rounded-3xl shadow-lg grid bg-white"
          >
            <div className="text-center text-black mb-3 lg:mb-5">
              <p className="text-primary font-medium my-1.5 lg:my-3">
                SERVICE - 0{i + 1}
              </p>
              <h3 className="font-medium text-2xl lg:text-3xl">{v.txt1}</h3>
            </div>
            <div className="relative w-full h-52 xl:h-60 rounded-md overflow-hidden">
              <img
                className="!relative w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                alt="img"
                src={v.img}
                width={400}
                height={400}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Service;
